import { createStore } from 'vuex'

import ENV from '@/utils/environment'

import accreditedNetwork from './accreditedNetwork'
import appointment from './appointment'
import bud from './bud'
import channel from './channel'
import cockpit from './cockpit'
import counterReferral from './counterReferral'
import dalyaRecommendation from './dalyaRecommendation'
import eita from './eita'
import errors from './errors'
import featureConfig from './featureConfig'
import file from './file'
import handoff from './handoff'
import healthcareMap from './healthcareMap'
import healthEvents from './healthEvents'
import healthLogics from './healthLogics'
import hospitalization from './hospitalization'
import laboratoryTestUploadResults from './laboratoryTestUploadResults'
import locations from './locations'
import member from './member'
import memed from './memed'
import permissions from './permissions'
import pillars from './pillars'
import procedures from './procedures'
import refund from './refund'
import risk from './risk'
import secondOpinion from './secondOpinion'
import specialist from './specialist'
import staff from './staff'
import summary from './summary'
import surgery from './surgery'
import tertiaryIntention from './tertiaryIntention'
import testResultsAnalyze from './testResultsAnalyze'
import ui from './ui'
import user from './user'
import virtualClinic from './virtualClinic'
import womensHealth from './womensHealth'

const store = createStore({
  strict: !ENV.IS_PROD_ENVIRONMENT,
  modules: {
    accreditedNetwork,
    appointment,
    bud,
    channel,
    cockpit,
    eita,
    errors,
    featureConfig,
    file,
    handoff,
    healthcareMap,
    healthEvents,
    healthLogics,
    hospitalization,
    laboratoryTestUploadResults,
    locations,
    member,
    memed,
    permissions,
    pillars,
    procedures,
    refund,
    risk,
    secondOpinion,
    specialist,
    staff,
    surgery,
    tertiaryIntention,
    testResultsAnalyze,
    ui,
    user,
    virtualClinic,
    womensHealth,
    counterReferral,
    summary,
    dalyaRecommendation
  }
})

export default store
